import React, { useContext, useEffect, useState } from 'react';
import cookieManagement from '../utilities/Cookie';
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post.js";
import DashBoardFinderApi from '../services/dashboardService'; 
import Dashboard from '../components/LandingPage/DashBoard'
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import moment from "moment";
import ProductStatistics from '../components/LandingPage/ProductionStatistics'
import { loopBackDomain, loopBackPort } from "environment/environment";
import {
  LandingContainer,
  LandingContent,
  LandingItems,
  LandingH1,
  LandingP,
  LandingBtn
} from './home/LandingElements';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import ErrorFallback from "../components/ErrorFallback/ErrorFallback.js";
import cronParser from "cron-parser";
import NewDashBoard from '../components/LandingPage/NewDashBoard';
const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');
let urlhost = window.location.host;
const domain = urlhost.split('.');
const subDomain = domain[1] +"."+ domain[2];


const PageType0 = props => {
  const {location:curentlocation} = props;
  const currentPath = curentlocation.pathname;

  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData?.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const [locationWiseCount, setLocationWiseCount] = useState({});
  const [selected, setSelected] = useState([]);
  let [date, setDate] = useState(moment())
  const [renderStatistics, setRenderStatistics] = useState(false);;
  let arr = [];
  let [previousSelectedDates,setPreviousSelectedDates] = useState()
  let [isLoader, setIsLoader] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [adminLocations, setAdminLocations] = useState(null)
  let [filters, setFilters] = useState({})
  const [apiData, setApiData] = useState(null);
  const [cacheChecked, setCacheChecked] = useState(false);
  const [loading, setLoading] = React.useState(true);
  const [productionApiData, setProductionApiData] = useState(null)
  const [loadingStates, setLoadingStates] = useState({
    productionStatistics: false,
    dashboard: false,
  });
  let [location, setLocation] = useState('all')
  let [loc, setLoc] = useState('all')
  let [responseData, setResponseData] = useState({})
  let [responseData1, setResponseData1] = useState({})
  const { t, i18n } = useTranslation();
  const [params, setParams] = useState();
  let [walletVal, setWalletVal] = useState({});
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
  });
  const [response, setResponse] = useState(null);
  const [permissions, setPermissions] = useState({});
  const shouldRenderProductStatistics = currentPath.includes('/product-statistics'); 


  let dateFilters;
  let locations = [];

  let dynamicParameters = {
    user_id: cookies.get('user_id'),
    customer_id: cookies.get('customer_id'),
    src_loc_id: cookies.get('userLocation_id'),
    userRole_name: cookies.get('userRole_name'),
    location: location,
    from_date: date.format('YYYY-MM-DD'),
    to_date: date.format('YYYY-MM-DD'),
    userLocation_id: cookies.get('userLocation_id'),
    // language: language
  }


  const handleLoading = () => {
    setLoading(false);
  }

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  }


  // useEffect(() => {
  //   if( monthWiseCount?.locations && monthWiseCount?.locations !== undefined)
  //   setSelectedOptions([{ label: "Select All", value: "*" }, ...monthWiseCount?.locations !== undefined ? monthWiseCount?.locations : '']);
  // }, [monthWiseCount.locations]);

  const dateFilter = ({ selectedOption, slectedDates, locationsData }) => {
    try{
    let from_date = null;
    let to_date = null;
    setPreviousSelectedDates('')
    console.log("@slectedDates",Array.isArray(slectedDates) && slectedDates[0] !== '' || slectedDates[1] !== '')
    switch (selectedOption) {
      case '90 days':
        from_date = moment().subtract(89, "days").format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD')
        break;
      case '30 days':
        from_date = moment().subtract(29, "days").format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD')
        break;
      case 'today':
        from_date = moment().format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD');
        break;
      default:
        if (Array.isArray(slectedDates) && slectedDates[0] !== '' && slectedDates[1] !== '') {
          setPreviousSelectedDates(slectedDates)
          from_date = slectedDates[0] 
          to_date =  slectedDates[1] 
        } else {
          from_date = previousSelectedDates ? previousSelectedDates[0] : null
          to_date =  previousSelectedDates ? previousSelectedDates[1] : null
        }
        // else {
        //   from_date = slectedDates ? slectedDates[0] : date.format('YYYY-MM-DD')
        //   to_date = slectedDates ? slectedDates[1] : date.format('YYYY-MM-DD')
        // }
      // from_date = slectedDates ? slectedDates[0] == '' ? null : slectedDates[0] : null
      // to_date = slectedDates ? slectedDates[1] == '' ? null : slectedDates[1] : null
    }
    if (from_date != null && to_date != null) {
      setFilters({
        from_date,
        to_date,
      })
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  //   async function getApiFunction(urlParams){
  //     let totalParams = {}
  //     let getURL = pageLayoutData[0].apiEndPoint;
  //       totalParams = {...params, ...selected}
  //     let paramsConverted = new URLSearchParams(totalParams);
  //     getURL = (`${getURL}?${paramsConverted.toString()}`);
  //     let responseData = await FetchAPI(getURL)
  //     if (responseData.status == 200) {
  //       setIsLoader(false)
  //         // setError(false);
  //         let responseDataJson = await responseData.json();
  //       if(responseDataJson.data){
  //       setMonthWiseCount(responseDataJson.data)
  //       }
  //   }
  // }


  // useEffect(() => {
  //   (async () => {
  //     let getURL = pageLayoutData[0].apiEndPoint;
  //     let totalParams,location;
  //     if (selected.length !== 0 && adminLocations !== undefined) {
  //       location = selected.length === adminLocations.length ? loc : [...selected.map(loc => loc.value)]
  //     }else{
  //       if(selected.length === 0){
  //       location = 'all'
  //       }
  //     }
  //     if (pageLayoutData[0].firstTimeParameters !== null) {
  //       const firstTimeParameters = pageLayoutData[0].firstTimeParameters;
  //       totalParams = { ...totalParams, ...firstTimeParameters }
  //     }
  //     totalParams = { ...totalParams, ...dynamicParameters, ...filters, location : location}
  //     setParams(totalParams)
  //     let paramsConverted = new URLSearchParams(totalParams);
  //     getURL = (`${getURL}?${paramsConverted.toString()}`);
  //     setIsLoader(true)
  //     let responseData = await FetchAPI(getURL);
  //     if (responseData.status == 200) {
  //       setIsLoader(false)
  //       // setError(false);
  //       let responseDataJson = await responseData.json();
  //       setResponseData(responseDataJson)
  //       setResponseData1(responseDataJson)
  //     }
  //   })()
  // }, [selected])

  useEffect(() => {
    try{
    (async () => {
      if (pageLayoutData != 'undefined') {
        let totalParams;
        let getURL = pageLayoutData[0].apiEndPoint;
        if (selected.length !== 0 && adminLocations !== undefined && adminLocations !== null && selected.length !== 1) {
          location = selected.length === adminLocations.length ? loc : [...selected.map(loc => loc.value)]
        } else {
          if (selected.length === 0) {
            location = 'null'
          }else if (selected.length === 1)
          location = selected.map((el) => el.value)
        }
        if (pageLayoutData[0].firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[0].firstTimeParameters;
          totalParams = { ...totalParams, ...firstTimeParameters, ...filters }
        }
        if (pageLayoutData[0].apiEndPointType === 'GET') {
          if ((filters.from_date !== null && filters.to_date !== null)) {
            totalParams = { ...totalParams, ...dynamicParameters, ...filters, location : location }
            let paramsConverted = new URLSearchParams(totalParams);
            getURL = (`${getURL}?${paramsConverted.toString()}`);
            setIsLoader(true)
            let responseData = await FetchAPI(getURL);
            if (responseData.status == 200) {
              setIsLoader(false)
              // setError(false);
              let responseDataJson = await responseData.json();
              if (responseDataJson.data) {
                setLocationWiseCount(responseDataJson.data)
              }
            }
            else {
              // setloadTableData(false);
              // setError(true);
              // setErrorMsg('Oops..! Something went wrong.');
            }
          }
        }
        else {
          totalParams = { ...totalParams, ...dynamicParameters, ...filters}
          let responseData = await PostAPI(getURL, totalParams);
        }
      }
    })()
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [selected, filters.from_date, filters.to_date])



  useEffect(() => {
    try{
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [globalLoadIndicator]);

  useEffect(() => {
    try{
    window.addEventListener("load", handleLoading);
    return () => window.removeEventListener("load", handleLoading);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [])

    let walletStatement = null;
    const lablstyle = { fontWeight: 'bold', color: 'black', fontSize: '14px' }


  useEffect(() => {
    try{
    (async () => {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const payload = {
        pageTypeID: 0,
        featureID: 1
      };
      cookies.set('feature_id', 1, { path: '/' });
      await setGlobalLoadIndicator('1');
      let response = await PostAPI(url, payload);
      await setFeatureBlueprint(response);
      await setGlobalLoadIndicator('2');
    })()
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [])

    // useEffect(() => {
    //   const fetchDashboardData = async() => {
    //   const payload = {
    //     user_id: dynamicParameters.user_id,
    //     customer_id: dynamicParameters.customer_id
    //   }  
    //   const dashboardResponse = await PostAPI("https://login-stg.esealcom.com:3003/dashboard/data", payload)
    //   setResponse(dashboardResponse);
    //   setPermissions(dashboardResponse.data.data.permissions)
    //   }
    //   fetchDashboardData();
    // },[])


    const cacheProvider = () => {
      // Retrieve cache from localStorage, or use an empty object if not found
      const localCache = localStorage.getItem('dashboardCache');
      const cacheMap = localCache ? new Map(JSON.parse(localCache)) : new Map();

      // Return an object with `get`, `set`, and `delete` methods to manage the cache
      return {
        get: (key) => cacheMap.get(key),
        set: (key, value) => {
          const timestampedValue = { data: value, lastUpdated: Date.now() };
          cacheMap.set(key, timestampedValue);
          // Save the updated cache to localStorage
          localStorage.setItem('dashboardCache', JSON.stringify([...cacheMap]));
        },
        delete: (key) => {
          cacheMap.delete(key);
          localStorage.setItem('dashboardCache', JSON.stringify([...cacheMap]));
        },
        clear: () => {
          localStorage.removeItem('dashboardCache');
          cacheMap.clear();
        },
      };
    };


    useEffect(() => {
      // Check if the cache is available or if we need to fetch data
      const fetchData = async () => {
        if (cacheChecked && !apiData) {
          try {
            const baseUrl = `login-stg.${subDomain}`
            setLoadingStates((prevState) => ({ ...prevState, dashboard: true }));
            const payload = {
              user_id: dynamicParameters.user_id,
              customer_id: dynamicParameters.customer_id
            }
            const {apiResp, cacheProviderValue} = await DashBoardFinderApi.getDashboard(baseUrl, 'dashboard/data', payload);
            if (!apiResp.status) {
              throw new Error(`Error: ${apiResp.status}`);
            }
            setLoadingStates((prevState) => ({ ...prevState, dashboard: false }));
            setPermissions(apiResp.permissions)
            cacheProvider().set('dashboard', cacheProviderValue || {});
            setApiData(cacheProviderValue);
            return cacheProviderValue;
          } catch (error) {
            console.error("Failed to fetch data:", error)
            setLoadingStates((prevState) => ({ ...prevState, dashboard: false }));
            return null; // No cache fallback as we're using in-memory cache only
          }
        }
      };
      fetchData(); // Call the fetch function when the component mounts or cacheChecked changes
    }, [cacheChecked, apiData]);




    useEffect(() => {
      const persistCache = () => {
        // Check if the cache already exists in localStorage
        const storedCache = localStorage.getItem('dashboardCache');
        if (storedCache) {
          const parsedCache = new Map(JSON.parse(storedCache));
          const cachedData = parsedCache.get('dashboard');
          if (cachedData) {
            const { data, lastUpdated } = cachedData;
            const todayNight = new Date();
            todayNight.setHours(0, 0, 0, 0);
            const isCacheExpired = lastUpdated < todayNight.getTime();
            if (isCacheExpired) {
              cacheProvider().clear();
              setApiData(null);
              setCacheChecked(true);
            } else {
              setApiData(data);
              setPermissions(data?.permissions);
            }
          }
        } else {
          setCacheChecked(true)
        }
      };

      persistCache();
    }, []);

    useEffect(() => {
        const cronExpression = '0 0 * * *'; 

      const scheduleNextCall = () => {
        try {
          // Parse the cron expression to get the next execution time
          const interval = cronParser.parseExpression(cronExpression);
          const nextExecution = interval.next();


          // Calculate the delay time (in milliseconds) until the next execution
          const timeToWait = nextExecution.getTime() - new Date().getTime();
          // Set a timeout to trigger the API call at the next execution time
          setTimeout(() => {
            cacheProvider().clear();
              setApiData(null);
            setCacheChecked(true); // Reset cacheChecked to true to trigger a fetch
            scheduleNextCall();
          }, timeToWait);
        } catch (error) {
          console.error("Error while scheduling the task:", error);
        }
      };

      // Start scheduling the task whenever the component mounts
      scheduleNextCall();

      // Clean the effect up on component unmounts
      return () => {
        console.log("Cleanup scheduling task");
      };
    }, []);


    useEffect(() => {
      if (shouldRenderProductStatistics) {
        setRenderStatistics(true);
      }
    }, [shouldRenderProductStatistics]);

    useEffect(() => {
      (async () => {
        try {
      if (pageLayoutData != 'undefined') {
        if (currentPath.includes('/product-statistics')) {
          const baseUrl = `login-stg.${subDomain}`
          let endPoint = 'dashboard/get-data';
          setLoadingStates((prevState) => ({ ...prevState, productionStatistics: true }));
                let totalParams = {
                  user_id: cookies.get('user_id'),
                  customer_id: cookies.get('customer_id'),
                  user_location_id:cookies.get('userLocation_id'),
                  start_from:0,
                }
              const responseData =  await DashBoardFinderApi.getProductionStatistics(baseUrl, endPoint, totalParams);
              if (responseData) {
                setProductionApiData(responseData);
              setLoadingStates((prevState) => ({ ...prevState, productionStatistics: false }));
              }
            }
          }
        } catch (error) {
          console.error("Failed to fetch data:", error);
        } finally {
          setLoadingStates((prevState) => ({ ...prevState, productionStatistics: false }));
        }
      })();
    }, [pageLayoutData]); 





  let commonParameters = {
    customer_id: cookies.get('customer_id'),
    user_id: cookies.get('user_id'),
  }

  let domain = (window.location.hostname).split(/[-.]/);
  let clientName = domain[0].toUpperCase()
  Object.keys(locationWiseCount).forEach((el) => {
    if(el.includes('Permission')){
      arr.push(locationWiseCount[el])
    }
  })
  
  let content;

  
  if (renderStatistics) {
    content = (
      <ProductStatistics apiData={productionApiData} isLoading={loadingStates.productionStatistics}/>
    )
}else if(permissions?.isView ){
  content = (
      <NewDashBoard apiData={apiData} isLoading={loadingStates.dashboard} />
    )
  }else if (!permissions?.isView && cookies.get('customer_id') === '13') {
    content = (
    <div className={arr.some((el) => el === true) ? 'content' : null}>
      <Dashboard
        dateFilter={dateFilter}
        isLoader={loading}
        count={locationWiseCount}
        setSelected={setSelected}
        setAdminLocations={setAdminLocations} />
    </div>
    )
  } else {
    content = (
    <LandingContainer>
      <LandingItems>
        <div style={{ color: "white", fontFamily: "Roboto", fontSize: "42px" }} >WELCOME TO {clientName}</div>
      </LandingItems>
    </LandingContainer>
    )
  }

  return content;
}

export default PageType0;